/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-06 17:49:32
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-04-20 17:09:36
 * @name: 忘记密码对象
 * @Description: 忘记密码对象
 * @FilePath: \preSaleNafterSaleBackstage\src\object\login\forgetPassword.class.js
 * @Author: DESKTOP-1QU67QM
 */
const forgetPassword = class forgetPassword {
    constructor() {
        this.telephone = ''; //手机号
        this.verificationCode = ''; //验证码
        this.newPassword = ''; //新密码
        this.newPasswordAgain = ''; //二次输入新密码
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 提交密码修改
     * @return {Promise} resolve: 成功回调, reject: 失败回调
     */
    async submit() {
        let params = {
            telephone: this.telephone,
            newPassword: this.newPassword,
            newPasswordAgain: this.newPasswordAgain,
            verificationCode: this.verificationCode,
        }
        return Promise.resolve();
    }
}

export default forgetPassword;
